export const ApproveStateEnum = {
  /**全部 null */
  all: null,
  /**草稿中 N */
  draft: "N",
  /**已通过 Y */
  pass: "Y",
  /**已驳回 R */
  reject: "R",
  /**已撤销 C*/
  cancel: "C",
  /**审批中 A */
  approval: "A",
};

export const ApproveStateMap = {
  /**全部 */
  [ApproveStateEnum.all]: {
    label: "全部",
    className: "",
  },
  /**草稿中 */
  [ApproveStateEnum.draft]: {
    label: "草稿中",
    className: "cancel-btn",
  },
  /**已通过 */
  [ApproveStateEnum.pass]: {
    label: "已通过",
    className: "pass-btn",
  },
  /**已驳回 */
  [ApproveStateEnum.reject]: {
    label: "已驳回",
    className: "reject-btn",
  },
  /**已撤销 */
  [ApproveStateEnum.cancel]: {
    label: "已撤销",
    className: "cancel-btn",
  },
  /**审批中 */
  [ApproveStateEnum.approval]: {
    label: "审批中",
    className: "ing-btn",
  },
};

export const ApproveStateOption = [
  { label: "全部", value: ApproveStateEnum.all },
  { label: "草稿中", value: ApproveStateEnum.draft },
  { label: "审批中", value: ApproveStateEnum.approval },
  { label: "已通过", value: ApproveStateEnum.pass },
  { label: "已驳回", value: ApproveStateEnum.reject },
  { label: "已撤销", value: ApproveStateEnum.cancel },
];

/**是否上传盖章合同 */
export const StampContractEnum = {
  /**全部  null*/
  ALL: null,
  /**已上传 2 */
  uploaded: "2",
  /**未上传 1 */
  notUploaded: "1",
  /**已确认 3 */
  confirmed: "3",
};

export const StampContractMap = {
  /**全部 */
  [StampContractEnum.ALL]: {
    label: "全部",
    className: "",
  },
  /**未上传 */
  [StampContractEnum.notUploaded]: {
    label: "未上传",
    className: "ing-btn",
  },
  /**已上传 */
  [StampContractEnum.uploaded]: {
    label: "已上传",
    className: "pass-btn",
  },
  /**已确认 */
  [StampContractEnum.confirmed]: {
    label: "已确认",
    className: "pass-btn",
  },
};

export const StampContractOption = [
  { label: "全部", value: StampContractEnum.ALL },
  { label: "未上传", value: StampContractEnum.notUploaded },
  { label: "已上传", value: StampContractEnum.uploaded },
  // { label: "已确认", value: StampContractEnum.confirmed },
];

/**是否上传回寄单号 */
export const ExpressDeliveryEnum = {
  /**未上传 */
  N: "N",
  /**已上传 */
  Y: "Y",
  /**全部 */
  ALL: null,
};

/**上传上传回寄单号 */
export const ExpressDeliveryList = [
  { label: "全部", value: ExpressDeliveryEnum.ALL },
  { label: "已上传", value: ExpressDeliveryEnum.Y },
  { label: "未上传", value: ExpressDeliveryEnum.N },
];

/**合同生效状态 */
export const ContractUseStateEnum = {
  /**未生效 0 */
  NOTEFFECTIVE: "0",
  /**已生效 1 */
  EFFECTIVE: "1",
  /**已终止 2 */
  TERMINATION: "2",
  /**已作废 3 */
  INVALID: "3",
};

export const ContractUseStateMap = {
  /**未生效 */
  [ContractUseStateEnum.NOTEFFECTIVE]: {
    label: "未生效",
    tips: "合同盖章流程流程未通过状态（审批中、已撤销、已驳回）",
    className: "ing-btn",
  },
  /**已生效 */
  [ContractUseStateEnum.EFFECTIVE]: {
    label: "已生效",
    tips: "合同盖章流程审批已通过，且合同效期未过期的",
    className: "pass-btn",
  },
  /**已终止 */
  [ContractUseStateEnum.TERMINATION]: {
    label: "已终止",
    tips: "代表合同曾经生效过，但是提前终止或者合同到期终止了",
    className: "reject-btn",
  },
  /**已作废 */
  [ContractUseStateEnum.INVALID]: {
    label: "已作废",
    tips: "合同还没有正式生效过，因各种原因（如条款谈不拢、不合作了等）；",
    className: "cancel-btn",
  },
};

/**合同状态 下拉晒选项 */
export const ContractUseStateOption = [
  { label: "已生效", value: ContractUseStateEnum.EFFECTIVE },
  { label: "未生效", value: ContractUseStateEnum.NOTEFFECTIVE },
  { label: "已终止", value: ContractUseStateEnum.TERMINATION },
  { label: "已作废", value: ContractUseStateEnum.INVALID },
];
